<div>
    <h1>Interview case details</h1>
    <form (ngSubmit)="onSubmit()" #caseDataInputForm="ngForm">
        <div class="form-group">
            <label for="case-id">Case ID</label>
            <input type="text" class="form-control" id="case-id" name="caseId"
                   [(ngModel)]="resourceIdentifier.caseId"
                   #caseId="ngModel"
                   required>
        </div>
        <div [hidden]="caseId.valid || caseId.pristine"
             class="alert alert-danger">
            Case ID is a required field
        </div>

        <div *ngIf="options == null || options.length == 0">
            <div class="form-group">
                <label for="interview-code">Interview code</label>
                <input type="text" class="form-control" id="interview-code" name="interviewCode"
                       [(ngModel)]="resourceIdentifier.interviewCode"
                       #interviewCode="ngModel"
                       required/>
            </div>
            <div [hidden]="interviewCode.valid || interviewCode.pristine"
                 class="alert alert-danger">
                Interview Code is a required field
            </div>
        </div>

        <div *ngIf="options != null && options.length > 0">
            <div class="form-group">
                <label for="interview-code">Interview code</label>
                <select type="text" class="form-control" id="interview-code-select" name="interviewCode"
                        [(ngModel)]="resourceIdentifier.interviewCode" required>
                    <option *ngFor="let option of options" value="{{option}}">{{option}}</option>
                </select>
            </div>
        </div>

        <div class="form-group">
            <label for="life-instance">Life instance</label>
            <input type="number" class="form-control" id="life-instance" name="lifeInstance"
                   [(ngModel)]="resourceIdentifier.lifeInstance"
                   #lifeInstance="ngModel"
                   required>
        </div>
        <div [hidden]="lifeInstance.valid || lifeInstance.pristine"
             class="alert alert-danger">
            Life Instance is a required field
        </div>

        <div class="form-group">
            <label for="interview-instance">Interview instance</label>
            <input type="number" class="form-control" id="interview-instance" name="interviewInstance"
                   [(ngModel)]="resourceIdentifier.interviewInstance">
        </div>
        <button type="submit" class="btn btn-outline-success" [disabled]="!caseDataInputForm.valid">Submit</button>
    </form>
</div>
